module.exports = __webpack_public_path__ + "static/lab-logo-white-834da20816ece9bf24e49db77b26bdff.svg";